import React from 'react';
import styled from 'styled-components';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import theme from '../../theme';

const CTASection = styled.section`
  background-color: ${theme.colors.secondary};
  color: ${theme.colors.white};
  padding: 5rem 0;
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 300px;
    height: 300px;
    background-color: ${theme.colors.primary};
    opacity: 0.1;
    border-radius: 50%;
    transform: translate(150px, -150px);
  }
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 200px;
    height: 200px;
    background-color: ${theme.colors.accent};
    opacity: 0.1;
    border-radius: 50%;
    transform: translate(-100px, 100px);
  }
`;

const CTAContent = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
`;

const CTATitle = styled.h2`
  font-size: ${theme.fontSizes.xxlarge};
  margin-bottom: 1.5rem;
  
  span {
    color: ${theme.colors.primary};
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: ${theme.fontSizes.xlarge};
  }
`;

const CTADescription = styled.p`
  font-size: ${theme.fontSizes.medium};
  margin-bottom: 2.5rem;
  opacity: 0.9;
`;

const CTAButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    flex-direction: column;
    align-items: center;
  }
`;

const PrimaryButton = styled(Link)`
  display: inline-block;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  border: 2px solid ${theme.colors.primary};
  padding: 1rem 2.5rem;
  font-size: ${theme.fontSizes.medium};
  font-weight: 600;
  border-radius: ${theme.borderRadius};
  transition: ${theme.transition};
  
  &:hover {
    background-color: transparent;
    color: ${theme.colors.white};
  }
`;

const SecondaryButton = styled(Link)`
  display: inline-block;
  background-color: transparent;
  color: ${theme.colors.white};
  border: 2px solid ${theme.colors.white};
  padding: 1rem 2.5rem;
  font-size: ${theme.fontSizes.medium};
  font-weight: 600;
  border-radius: ${theme.borderRadius};
  transition: ${theme.transition};
  
  &:hover {
    background-color: ${theme.colors.white};
    color: ${theme.colors.secondary};
  }
`;

const CallToAction = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  
  return (
    <CTASection>
      <div className="container">
        <CTAContent>
          <CTATitle dangerouslySetInnerHTML={{ __html: t('cta.title') }} />
          <CTADescription>
            {t('cta.description')}
          </CTADescription>
          <CTAButtonGroup>
            <PrimaryButton to={`/${lang}/demo`}>{t('cta.primaryButton')}</PrimaryButton>
            <SecondaryButton to={`/${lang}/contact`}>{t('cta.secondaryButton')}</SecondaryButton>
          </CTAButtonGroup>
        </CTAContent>
      </div>
    </CTASection>
  );
};

export default CallToAction; 